module.exports = __webpack_public_path__ + "img/Sport Center.8027c351.svg";